export default __webpack_public_path__ + "static/media/logox0.25.62eeb42b.svg";